import { useEffect, useRef } from 'react';

const AdUnit = ({
  adSlot,
  adFormat = 'horizontal',
  fullWidthResponsive = true,
  style,
  className = ''
}) => {
  const adRef = useRef(null);
  const isAdPushed = useRef(false);

  useEffect(() => {
    try {
      if (adRef.current && !isAdPushed.current) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        isAdPushed.current = true;
      }
    } catch (error) {
      console.error('AdUnit error:', error);
    }
  }, []);

  return (
    <div className="ad-center-wrap">
      <ins
        ref={adRef}
        className={`adsbygoogle ad-center-ins ${className}`}
        style={style}
        data-ad-client="ca-pub-4567670556689776"
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        data-full-width-responsive={fullWidthResponsive}
      />
    </div>
  );
};

export default AdUnit;
